import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { auth } from '../firebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { setUser } from '../store/userSlice';
import { Box, Button, Card, TextField, Typography, Alert } from '@mui/material';
import { getFirebaseErrorMessage } from '../utils/errorMessages';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const userData = {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        photoURL: user.photoURL
      };
      const accessToken = await user.getIdToken();

      dispatch(setUser({ userData, accessToken }));
      navigate('/');
    } catch (err) {
      console.log('Caught error:', err);
      setError(getFirebaseErrorMessage(err));
    }
  };

  return (
    <Card sx={{ maxWidth: 400, mx: 'auto', my: 4, py: 3, px: 2 }}>
      <Typography variant="h6" component="h1" textAlign="center" mb={2}>
        Login
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          type="email"
          label="Email Address"
          required
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          type="password"
          label="Password"
          required
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ mb: 2 }}
        />
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mb: 2 }}>
          Login
        </Button>
        <Box sx={{ textAlign: 'right' }}>
          <Button component={Link} to="/register" variant="text" color="primary">
            Don't have an account? Register
          </Button>
        </Box>
      </Box>
    </Card>
  );
}
